import api from '../lib/utils/apiConfig';

const pageService = {
  getPages: async (search) => {
    const response = await api.get('/pages/admin', { params: { search } });
    return response.data;
  },

  getPageById: async (id) => {
    const response = await api.get(`/pages/admin/${id}`);
    return response.data;
  },

  createPage: async (data) => {
    const response = await api.post('/pages/admin', data);
    return response.data;
  },

  updatePage: async (id, data) => {
    const response = await api.put(`/pages/admin/${id}`, data);
    return response.data;
  },

  deletePage: async (id) => {
    const response = await api.delete(`/pages/admin/${id}`);
    return response.data;
  },

  updatePageOrder: async (orders) => {
    const response = await api.put('/pages/admin/reorder', { orders });
    return response.data;
  }
};

export default pageService;
